export default "__VITE_ASSET__0Yxkm69K__"